// Smooth-scrolls to an in-page section and moves focus there, so keyboard and
// screen-reader users land on the right content instead of just the viewport.
export function scrollToId(id) {
  const element = document.getElementById(id);
  if (!element) return;

  element.scrollIntoView({ behavior: 'smooth', block: 'start' });

  if (!element.hasAttribute('tabindex')) {
    element.setAttribute('tabindex', '-1');
  }
  element.focus({ preventScroll: true });
}

export default scrollToId;
